'use strict';

require("moduleFold/notifiche/scripts/index.js");
require("moduleFold/datasource/scripts/index.js");
var BssBasicField = require("moduleFold/formbuilder/scripts/mixins/BssBasicField");

/**
 * Campo di tipo entity su entity esterna
 * 
 * @class  
 * @param {type} formlyConfig
 * @param {type} formlyValidationMessages
 * @param {Valida} Valida
 */
function BssMappaStatiTracking(formlyConfig, formlyValidationMessages, Valida){
    formlyConfig.setType($.extend(true, {}, new BssBasicField(), {
        name: 'bssmappastatitracking', 
        //extends: 'bssinput',
        template: require("./bssmappastatitracking.html"),
        controller: ["$scope", "$rootScope", "$filter", "$timeout", "$http", "$state", "ErrorManager", "DSFactory", require("./BssMappaStatiTrackingController")],
        defaultOptions: {
            ngModelElAttrs: {
                'cssCategory': 'bssmappastatitracking'
            },
        }
    }));
}

module.exports = BssMappaStatiTracking;